// @ts-check
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//

import Box from "@mui/material/Box";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
import ButtonMain from "../../../../../../common/components/button/ButtonMain";
import { StoreContext } from "../../../../../../store/StoreProvider";
import Act from "../../../../../../store/actions";
import useLocaleRoute from "../../../../../../common/hooks/useLocaleRoute";
import urls from "../../../../../../api/project/ApiUrls";
import useModulePublic from "../../../../../hooks/useModulePublic";
import fireAuth from "../../../../../../api/firebase/auth/utils";
//
import {
  saveAnalyticsSetting,
  isChanged,
} from "../../settingControl/useSetting";
import { MODULE_ID } from "../../../../../../config/CONSTANTS";
import { SNA_ANALYTICS_TYPE } from "../../../../../../config/config.sna";

const BottomPanel = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  // @ts-ignore
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { analytics } = sna;
  const { startAnalysis, analyticsType } = analytics;
  // local state
  const [test, setTest] = useState(0);
  const [datasetSelect, setDatasetSelect] = useState([]);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  /**
   *
   * @param moduleId {string}
   * @returns {boolean}
   */
  const handleDisabled = (moduleId) => !handlePublic(moduleId);
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);

  const dataChanged = isChanged(analytics, ["analyticsType"]);
  const disabledStartBtn = !dataChanged;
  const disabledCompleteAnaBtn = false;

  /**
   * 取得 button 樣式
   * @param disableStatus {boolean}
   * @returns {{}|{"&.MuiButton-root": {backgroundColor: string, color: string}}}
   */
  const getApplyBtnSx = (disableStatus) => {
    if (disableStatus) {
      return {
        "&.MuiButton-root": {
          color: "#909090",
          backgroundColor: "#505050",
        },
      };
    }
    return {};
  };

  const onStartAnalysis = () => {
    if (!startAnalysis) {
      dispatch({
        type: Act.SNA_ANALYTICS_START_ANALYSIS,
        payload: true,
      });
    }
    saveAnalyticsSetting(state, dispatch);
  };

  const onCompleteAnalysis = () => {
    dispatch({
      type: Act.SNA_ANALYTICS_TYPE_CHANGE,
      payload: SNA_ANALYTICS_TYPE.completeAnalysis.key,
    });
  };

  useEffect(() => {
    // 只要 analytics type 改變時,即開始分析
    const isDataChanged = isChanged(analytics, ["analyticsType"]);
    if (isDataChanged) {
      onStartAnalysis();
    }
  }, [analyticsType]);

  return (
    <Box my={4}>
      {/* <Box mb={2}> */}
      {/*  <ButtonMain */}
      {/*    buttonProps={{ */}
      {/*      text: intl.formatMessage({ */}
      {/*        id: "sna.sidebar.analytics.bottompanel.start.analysis", */}
      {/*        defaultMessage: "開始分析", */}
      {/*      }), */}
      {/*      fullWidth: true, */}
      {/*      onClick: onStartAnalysis, */}
      {/*      disabled: disabledStartBtn, */}
      {/*      variant: disabledStartBtn ? "disabled" : null, */}
      {/*      sx: { ...getApplyBtnSx(disabledStartBtn) }, */}
      {/*    }} */}
      {/*  /> */}
      {/* </Box> */}
      <Box mb={2}>
        <ButtonMain
          buttonProps={{
            text: intl.formatMessage({
              id: "sna.sidebar.analytics.bottompanel.complete.analysis",
              defaultMessage: "完整分析",
            }),
            fullWidth: true,
            onClick: onCompleteAnalysis,
            disabled: disabledCompleteAnaBtn,
            variant: disabledCompleteAnaBtn ? "disabled" : null,
            sx: { ...getApplyBtnSx(disabledCompleteAnaBtn) },
          }}
        />
      </Box>
    </Box>
  );
};

export default BottomPanel;
